import { useIntl } from 'react-intl';
import { Col, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import { ListItemInventoryParams } from '@/core/domain/inventory/inventories/Inventory.types';

function InventoryItemsExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListItemInventoryParams>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12} xl={6}>
        <Input
          value={queryParams?.manufacturingCode}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, manufacturingCode: value }))
          }
          placeholder={intl.formatMessage({
            id: 'inventory.page.form.modal.fetchItems.table.manufacturingCode',
          })}
        />
      </Col>

      <Col xs={24} md={12} xl={6}>
        <Input
          value={queryParams?.barCode}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, barCode: value }))
          }
          placeholder={intl.formatMessage({
            id: 'inventory.page.form.modal.fetchItems.table.barCode',
          })}
        />
      </Col>

      <Col xs={24} md={12} xl={6}>
        <Input
          value={queryParams?.companyCode}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, companyCode: value }))
          }
          placeholder={intl.formatMessage({
            id: 'inventory.page.form.modal.fetchItems.table.companyCode',
          })}
        />
      </Col>

      <Col xs={24} md={12} xl={6}>
        <Input
          value={queryParams?.sku}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, sku: value }))
          }
          placeholder={intl.formatMessage({
            id: 'inventory.page.form.modal.fetchItems.table.sku',
          })}
        />
      </Col>
    </Row>
  );
}

export default InventoryItemsExtraFilters;
